import { useContext, createContext } from 'react';

const CheckoutContext = createContext();
CheckoutContext.displayName = 'CheckoutContext';

export const useCheckoutContext = () => {
  const context = useContext(CheckoutContext);

  if (!context) {
    throw new Error(
      'useCheckoutContext must be used within the CheckoutContext.Provider'
    );
  }

  return context;
};

export default CheckoutContext;
